import { Alert, Spin } from 'antd';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { t } from 'ttag';

import useSearchParams from 'common/hooks/useSearchParams';

import Builder from '../Builder';
import { parseBadgeData } from '../designer-service';
import { useBadgeQuery } from '../queries';

const NOT_FOUND_ERROR_CODES = ['badges_templates_not_found', 'badges_not_found'];

const CaptureDesignPreview = () => {
  const query = useSearchParams();
  const token = query.get('token');
  const { resourceId } = useParams();

  const { data, isLoading, error } = useBadgeQuery(resourceId, token, {
    select: useCallback(res => {
      const parsed = parseBadgeData(res);

      return {
        badgeType: parsed.badge.badgeType,
        size: parsed.badge.size,
        orientation: parsed.badge.orientation,
        isBleedEnabled: parsed.badge.isBleedEnabled,
        background: parsed.design.background,
        widgets: parsed.design.widgets,
      };
    }, []),
  });

  if (error) {
    const notFound = NOT_FOUND_ERROR_CODES.includes(error.errors?.[0]?.code);
    return (
      <Alert
        type="error"
        message={notFound ? t`Resource was not found.` : t`Unknown error occurred.`}
        showIcon
      />
    );
  }

  if (isLoading) {
    return <Spin />;
  }

  return <Builder badge={data} person={null} showBorder={false} isLoading={false} />;
};

export default CaptureDesignPreview;
